interface ClerkErrorShape {
  code?: string;
  longMessage?: string;
  message?: string;
}

interface AuthResourceWithReset {
  reset: () => Promise<{ error: ClerkErrorShape | null }>;
}

interface ClerkClientWithReset {
  resetSignIn?: () => void;
  resetSignUp?: () => void;
}

export async function resetStaleOAuthState(options: {
  signIn: AuthResourceWithReset;
  signUp?: AuthResourceWithReset | null;
  clerkClient?: ClerkClientWithReset | null;
}): Promise<{ error: ClerkErrorShape | null }> {
  const { signIn, signUp, clerkClient } = options;

  const { error: signInResetError } = await signIn.reset();
  if (signInResetError) {
    return { error: signInResetError };
  }

  if (signUp) {
    const { error: signUpResetError } = await signUp.reset();
    if (signUpResetError) {
      return { error: signUpResetError };
    }
  }

  clerkClient?.resetSignIn?.();
  clerkClient?.resetSignUp?.();

  return { error: null };
}
